export default "/manual_order_logo.86a92ea5-c373e8.svg?svgr";